import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["select"]
  static values = { url: String }

  connect() {
    this.tomSelect = new TomSelect(this.selectTarget, {
      valueField: "id",
      labelField: "text",
      searchField: "text",
      preload: false,
      placeholder: "Search by name or email…",
      maxOptions: 50,
      create: false,
      allowEmptyOption: true,
      load: (query, callback) => {
        if (!query.length) return callback()
        const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
        fetch(url, { headers: { Accept: "application/json" } })
          .then(r => r.json())
          .then(callback)
          .catch(() => callback())
      }
    })
  }

  disconnect() {
    if (this.tomSelect) this.tomSelect.destroy()
  }
}
